import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { parseMoney } from './workbenchPricing';

export default function WorkbenchMoneyInput({
  amount,
  label,
  onChange,
  disabled = false,
}: {
  amount: number | undefined;
  label: string;
  onChange: (cents: number | null) => void;
  disabled?: boolean;
}) {
  const [raw, setRaw] = useState<string | null>(null);
  const value = raw ?? (amount == null ? '' : String(amount / 100).replace('.', ','));
  const invalid = parseMoney(value) === null;
  return (
    <div className="relative inline-flex max-w-full items-center">
      <span className="pointer-events-none absolute left-2 text-sm text-muted-foreground">€</span>
      <Input
        aria-label={label}
        aria-invalid={invalid}
        inputMode="decimal"
        disabled={disabled}
        className="h-8 w-28 pl-6 text-right tabular-nums aria-[invalid=true]:border-destructive"
        value={value}
        onFocus={() => setRaw(value)}
        onBlur={() => setRaw(null)}
        onChange={(event) => {
          setRaw(event.target.value);
          onChange(parseMoney(event.target.value));
        }}
      />
    </div>
  );
}
